// Dependencias generales
import { useEffect } from 'react';

import avatarHelias from '../../img/dark-theme/helias-avatar.png'
import logoFevergy from '../../img/dark-theme/fevergy-brand.svg'

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")

// Función del router
const InitialConfigHeader = (currentStep) => {

  useEffect(() => {  
    
    if( (localStorage.getItem("currentInstallations") !== null) && (parseInt(localStorage.getItem("currentInstallations")) > 1) ){
      document.getElementById("botonCancelarInstalacion").className = document.getElementById("botonCancelarInstalacion").className.replaceAll(" hidden", "")
      document.getElementById("botonDarmeDeBajaRegistroInicial").className = document.getElementById("botonDarmeDeBajaRegistroInicial").className.replaceAll(" hidden", "") + " hidden"
    }
    else{
      document.getElementById("botonCancelarInstalacion").className = document.getElementById("botonCancelarInstalacion").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("botonDarmeDeBajaRegistroInicial").className = document.getElementById("botonDarmeDeBajaRegistroInicial").className.replaceAll(" hidden", "")            
    }
    
    console.log("Cabecera cargada correctamente.")  
  });
  
  return (
    
    <header id="initialConfigBreadcrumb">        
      <div className="wrapper">
        
        { currentStep.step === "WELCOME" ?
          <figure>
            <img src={logoFevergy} alt="Helias"/>
          </figure>          
        :
          <figure className="helias">
            <img src={avatarHelias} alt="Helias"/>
          </figure>      
        }          
        
        <div className="horizontal gap-04">
          <button id="botonDarmeDeBajaRegistroInicial" className="link " onClick={ () => initialConfigCommonJS.realizarBajaDuranteRegistro()}>Darme de baja</button>
          <button id="botonCancelarInstalacion" className="link hidden" onClick={ () => initialConfigCommonJS.eliminarInstalacion()}>Cancelar nueva instalación</button>
          <a id="linkSalir" className="link" href="/Logout" >Salir</a>
        </div>
      </div>
    </header>           
  )
}

export default InitialConfigHeader